export const Brand = {
  YITTY: 'yitty',
  FABLETICS: 'fabletics',
  SAVAGE: 'savage',
};
